import * as tokens from '../../../../../tokens/box-shadow.light.generated.js';
export const globalBoxShadowLight = {
    boxShadow: {
        elevation: {
            level1: tokens.GLOBAL_BOX_SHADOW_ELEVATION_LEVEL1_LIGHT,
            level3: tokens.GLOBAL_BOX_SHADOW_ELEVATION_LEVEL3_LIGHT,
            level4: tokens.GLOBAL_BOX_SHADOW_ELEVATION_LEVEL4_LIGHT
        }
    }
};
//# sourceMappingURL=box-shadow.light.js.map